module.exports = __webpack_public_path__ + "img/ld-arraw.7e9ad4e4.png";